class PrivilegeController {


    constructor($scope, $state, $mdDialog, localStorageService, randomColorService, authService, PRIVILEGECONSTANT,$rootScope) {
        'ngInject';
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            $rootScope.title = "Roles & Privileges Dashboard"
        }
        this.$onDestroy = () => {
            $scope.roleModuleList = undefined
            $scope.modulewiseList = undefined
        }

        let dashboardUserAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
            return feature.module_state == "utilities"
        })

        $scope.getColor = randomColorService;
        $scope.userwise = true;
        $scope.usericon = "../../../img/roles_modules/roles_white.png"
        $scope.moduleicon = "../../../img/roles_modules/modules_dark.png"
        $scope.roleModuleList = [];
        $scope.modulewiseList = [];
        $scope.userSearchs = "";
        $scope.userSearch = "";
        $scope.school_id = localStorageService.get('school_id')
        $scope.toggleView = function () {
            $scope.userwise = !$scope.userwise;
            if ($scope.userwise) {
                $scope.usericon = "../../../img/roles_modules/roles_white.png"
                $scope.moduleicon = "../../../img/roles_modules/modules_dark.png"
            }
            if (!$scope.userwise) {
                $scope.usericon = "../../../img/roles_modules/roles_dark.png"
                $scope.moduleicon = "../../../img/roles_modules/modules_white.png"

            }
        }
        $scope.setPrivilege = (roleid, moduleid) => {

            $state.go('privilegeSettings', {
                'role_id': roleid,
                'module_id': moduleid

            })

        }

        function loadData() {
            /************ API CALL TO GET ALL ROLES & THEIR PRIVILEGES ***********/
            /* Function to display roles and their module status.
             * @school_id : String - 
             * @return : List of modules 
             * @Developer : Ashitha
            */

            authService.callAPI(PRIVILEGECONSTANT.API_GET_MODULE_LIST + $scope.school_id, "GET", {}, function (response) {
                if (response.result != undefined) {
                    if (response.result.data && response.result.data.data) {
                        let resultItem = response.result.data.data
                        $scope.roleList = response.result.data.data[0].role_list
                        let modules = [];
                        modules = response.result.data.data;
                        $scope.selectedModules = angular.copy(modules)
                        _.each(modules, function (obj) {
                            let roleList = [];
                            _.each($scope.roleList, function (role) {
                                let roleItem = {};
                                let featurerole = _.filter(obj.feature_role, function (item) {
                                    return role._id == item.role_id
                                })
                                roleItem.name = role.name;
                                roleItem._id = role._id;
                                roleItem.isAvailable = false;
                                if (featurerole.length > 0) {

                                    _.each(featurerole, function (obj) {
                                        _.each(obj.privilege, function (each) {
                                            if (each.status) {
                                                roleItem.isAvailable = true;
                                            }
                                        })
                                    })


                                } else {
                                    roleItem.isAvailable = false;
                                }
                                roleList.push(roleItem)

                            })
                            $scope.modulewiseList.push({
                                "_id": obj._id,
                                "name": obj.name,
                                color: randomColorService.getRandomColor(),
                                "roles": roleList
                            })
                        })
                        _.defer(function () { $scope.$apply(); });;
                        _.each($scope.roleList, function (role) {
                            let moduleList = [];
                            _.each(modules, function (obj) {
                                let module = {};
                                module.name = obj.name
                                module._id = obj._id
                                module.isAvailable = false;
                                let featurerole = _.filter(obj.feature_role, function (item) {
                                    return role._id == item.role_id
                                })

                                if (featurerole.length > 0) {
                                    _.each(featurerole, function (obj) {

                                        _.each(obj.privilege, function (each) {

                                            if (each.status) {
                                                module.isAvailable = true;

                                            }
                                        })
                                    })


                                } else {
                                    module.isAvailable = false;
                                }
                                moduleList.push(module)
                            })
                            $scope.roleModuleList.push({
                                "_id": role._id,
                                "name": role.name,
                                "color": randomColorService.getRandomColor(),
                                "modules": moduleList
                            })
                        })


                    }

                }
            })

        }

        /*
         * Set default privileges for selected roles and modules
         * 
         * @ev : Object - Click Event
         * 
         * @return : null
         */
        $scope.setPrivilgeAsDefault = (ev) => {
            var confirm = $mdDialog.confirm()
                .title('Are you sure you want to continue?')
                .textContent('This will set the default privileges to all the users')
                .ariaLabel('')
                .targetEvent(ev)
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {
                $scope.loading = true
                let dataToSend = {
                    module_state: _.pluck($scope.selectedModules, 'state'),
                    roles: $scope.roleList,
                    school_id: localStorageService.get('school_id')
                }
                /************ API CALL TO GET ALL DEFAULT PRIVILEGES ***********/
                /* Function to get all default privileges
                 * @school_id : String - 
                 * @return : modules with default privileges
                 * @Developer : Ashitha
                */
                authService.callAPI(PRIVILEGECONSTANT.API_SET_PRIVILEGE_DEFAULT, "POST", dataToSend, function (response) {
                    var result = response.result.data.data
                    if (result.length > 0) {
                        var selectedModules = result
                        // _.each(selectedModules, function (each) {
                        //     var finalList = [];
                        //     var resultModule = _.find($scope.selectedModules, function (mod) {
                        //         return each.state === mod.state
                        //     })
                        //     _.each(each.feature_role, function (eachItem) {
                        //         var counts = 0;
                              
                        //         //find whether the selected feature is new  or modified 
                        //         if (resultModule && resultModule.feature_role) {
                        //             var resObject = _.find(resultModule.feature_role, function (stat) {
                        //                 return eachItem.role_id === stat.role_id && eachItem.f_id === stat.f_id
                        //             })
                        //         }
                        //         //if modified ,then allowing to save
                        //         if (resObject) {
                        //             _.each(eachItem.privilege, function (data) {
                        //                 var objec = _.find(resObject.privilege, function (res) {
                        //                     return res.name === data.name && res.status === data.status
                        //                 })
                        //                 if (objec) {
                        //                     counts++
                        //                 }
                        //             })
                        //             if (counts != resObject.privilege.length) {
                        //                 //console.log("here")
                        //                 finalList.push(eachItem)
                        //             }
                        //         } else {
                        //             //if new and if any of the 'CRUD' item is true,then allowing to save
                        //             if (_.compact(_.pluck(eachItem.privilege, 'status')).length > 0) {
                        //                 finalList.push(eachItem)
                        //             }
                        //         }

                        //     })
                        //     each.feature_role = angular.copy(finalList)

                        // })
                        if (selectedModules) {
                            let objToSend = {
                                selected_modules: angular.copy(selectedModules),
                                school_id: localStorageService.get('school_id'),
                                flag:0
                            }
                            /************ API CALL TO UPDATE PRIVILEGE ***********/
                            /* Function to update  privileges
                             * @school_id : String -
                             * @ selected_modules: List of modules
                             * @return : null
                             * @Developer : Ashitha
                            */
                            authService.callAPI(PRIVILEGECONSTANT.API_UPDATE_PRIVILEGE, "POST", objToSend, function (response) {
                                $scope.loading = false
                                toastr.success("Successfully added")
                                $scope.modulewiseList = []
                                $scope.roleModuleList = []
                                loadData()
                            })
                        }
                    } else {
                        $scope.loading = false
                        toastr.error("Default privileges not found")
                    }
                    //_.defer(function() { $scope.$apply(); });
                })
            })
        }
        //$scope.roleModuleList=[]
        //$scope.modulewiseList=[]
        loadData()



    }
}

export default PrivilegeController;


// WEBPACK FOOTER //
// ./src/app/privilege/controllers/privilegeDashboardController.js